import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { useMonitoreo } from './MonitoreoContext';

const TIPOS = [
    { key: 'M', label: 'M', color: '#fe424d', field: 'resumenMantenimiento' },
    { key: 'A', label: 'A', color: '#ffc800', field: 'resumenAlmacen' },
    { key: 'P', label: 'P', color: '#2ccb9e', field: 'resumenProduccion' },
    { key: 'C', label: 'C', color: '#118DFF', field: 'resumenCalidad' },
];

export default function LlamadasActivasCounter() {
    const { promedioResumen } = useMonitoreo();

    return (
        <div className="andon-counters">
            <p className="andon-counters-title">Resumen de llamados por área</p>
            <div className="andon-counters-grid">
                {TIPOS.map((tipo) => (
                    <div key={tipo.key} className="andon-counter-item">
                        <Avatar
                            className="andon-counter-avatar"
                            ref={(node) => {
                                if (node) node.style.setProperty('--avatar-color', tipo.color);
                            }}
                        >
                            {promedioResumen[tipo.field] ?? 0}
                        </Avatar>
                        <p className="andon-counter-label">{tipo.label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
